import { useEffect, useRef } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import * as THREE from "three";
import { CAMERA } from "../config/game";
import { useGameStore } from "../state/useGameStore";

export function CameraRig() {
  const { camera } = useThree();
  const phase = useGameStore((s) => s.phase);
  const reducedMotion = useGameStore((s) => s.reducedMotion);
  const coarsePointer = useGameStore((s) => s.coarsePointer);
  const climaxActive = useGameStore((s) => s.climaxActive);

  const mouse = useRef({ x: 0, y: 0 });
  const look = useRef(new THREE.Vector3(0, 0.2, 0));
  const breath = useRef(0);

  useEffect(() => {
    const onMove = (e) => {
      mouse.current.x = (e.clientX / window.innerWidth) * 2 - 1;
      mouse.current.y = -((e.clientY / window.innerHeight) * 2 - 1);
    };
    window.addEventListener("pointermove", onMove, { passive: true });
    return () => window.removeEventListener("pointermove", onMove);
  }, []);

  useFrame((state, delta) => {
    const target =
      phase === "heap"
        ? CAMERA.heap
        : phase === "intro"
          ? CAMERA.intro
          : CAMERA.play;

    const parallax =
      reducedMotion || coarsePointer || phase === "heap" ? 0 : 0.55;

    const tx = target.x + mouse.current.x * parallax;
    const ty = target.y + mouse.current.y * parallax * 0.35;
    let tz = target.z;

    if (climaxActive && !reducedMotion) {
      breath.current = THREE.MathUtils.damp(breath.current, 1, 4, delta);
      tz -= breath.current * 0.85;
    } else {
      breath.current = THREE.MathUtils.damp(breath.current, 0, 5, delta);
    }

    camera.position.x = THREE.MathUtils.damp(camera.position.x, tx, 3.2, delta);
    camera.position.y = THREE.MathUtils.damp(camera.position.y, ty, 3.2, delta);
    camera.position.z = THREE.MathUtils.damp(camera.position.z, tz, 3.2, delta);

    const lookY = phase === "heap" ? -1.4 : 0.2;
    look.current.y = THREE.MathUtils.damp(look.current.y, lookY, 3, delta);
    camera.lookAt(look.current.x, look.current.y, look.current.z);
  });

  return null;
}
